import { SvgIcon, SxProps } from "@mui/material";
import CheckSvg from "jsx:../../../Images/Icons/FontAwesome/solid/check.svg";

export function SolidCheckIcon(props: SxProps) {
    return <SvgIcon component={CheckSvg} inheritViewBox sx={props} />;
}
